import React, { useRef, useState } from 'react';
import { Upload, Loader2, X } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { uploadAPI } from '../../lib/api';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const resolveUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  if (url.startsWith('/api/')) return `${API_URL}${url}`;
  return url;
};

export const ImageUpload = ({ value, onChange, label = 'Imagem' }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) {
      toast.error('Selecione um arquivo de imagem válido');
      return;
    }
    if (file.size > 8 * 1024 * 1024) {
      toast.error('Imagem demasiado grande (máx. 8MB)');
      return;
    }
    setUploading(true);
    try {
      const res = await uploadAPI.uploadImage(file);
      onChange(res.data.url);
      toast.success('Imagem carregada!');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Falha no upload');
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  const preview = resolveUrl(value);

  return (
    <div className="space-y-2" data-testid="image-upload">
      <div className="flex gap-2">
        <Input
          type="text"
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder="https://... ou faça upload"
          className="flex-1"
          data-testid="image-url-input"
        />
        <Button
          type="button"
          variant="outline"
          onClick={() => inputRef.current?.click()}
          disabled={uploading}
          className="border-[#0F5A34] text-[#0F5A34] hover:bg-[#0F5A34] hover:text-white"
          data-testid="image-upload-btn"
        >
          {uploading ? <Loader2 size={16} className="animate-spin mr-2" /> : <Upload size={16} className="mr-2" />}
          {uploading ? 'Enviando...' : 'Upload'}
        </Button>
      </div>
      <input
        ref={inputRef}
        type="file"
        accept="image/png,image/jpeg,image/jpg,image/webp,image/gif"
        onChange={handleFile}
        className="hidden"
      />
      {preview && (
        <div className="relative inline-block">
          <img
            src={preview}
            alt="Preview"
            className="h-28 w-auto rounded-sm border border-[#D6D2C4] object-cover"
            data-testid="image-preview"
          />
          <button
            type="button"
            onClick={() => onChange('')}
            className="absolute -top-2 -right-2 bg-[#E53935] text-white rounded-full w-6 h-6 flex items-center justify-center hover:bg-red-700"
            title="Remover"
            data-testid="image-remove-btn"
          >
            <X size={14} />
          </button>
        </div>
      )}
    </div>
  );
};

export default ImageUpload;
